module.exports = __webpack_public_path__ + "img/poly-6.4d3c5f01.png";